import "../css/nav.css"


function Nav() {
    return (
        <nav>
            <div className="title">
                <img src="../images/TrollFace.png" alt="" />
                <h1>meme generator</h1>
            </div>
            <div className="subtitle"></div>
        </nav>
    )
}

export default Nav;